module.exports = __webpack_public_path__ + "static/gboyega-613ede93be1d730159f737ed81ba2326.jpg";